import { inject, Injectable } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PortalClient } from '@system-dyg/shared/models';

@Injectable({ providedIn: 'root' })
export class PortalClientesPersonalizeSession {
  private account: PortalClient | null = null;

  set(account: PortalClient): void {
    this.account = account;
  }

  get(): PortalClient | null {
    return this.account;
  }

  clear(): void {
    this.account = null;
  }
}

export const portalClientesPersonalizeGuard: CanActivateFn = () => {
  const session = inject(PortalClientesPersonalizeSession);
  const router = inject(Router);
  return session.get() ? true : router.createUrlTree(['/']);
};
